<template>
  <el-dialog :visible.sync="showAddQuestion" width="788px" :title="title" :close-on-click-modal="false"
    :before-close="handleClose">
    <div class="dialog-main-content">
      <publicFoldSearch padBottom='0px' :setWidth='true' :searchList='searchList' v-on:getSearchObj='getSearchObj'>
      </publicFoldSearch>
      <div class="main-content-list">
        <el-table :data="tableData" @selection-change="handleSelectionLandPage" height="359px"
          :header-cell-style="{ textAlign: 'center', color: '#333333',fontSize: '14px',fontWeight: 'bold', backgroundColor: '#FAFAFA'}">
          <el-table-column type="selection" width="45" align='center'> </el-table-column>
          <el-table-column prop="name" label="落地页名称" show-overflow-tooltip width="150px" align='center'></el-table-column>
          <el-table-column prop="title" label="展示名称" show-overflow-tooltip align='center'></el-table-column>
          <el-table-column prop="belong" label="归属" show-overflow-tooltip align='center'>
            <template slot-scope="scope">{{ scope.row.belong==0?'平台':scope.row.hospitalName }}</template>
          </el-table-column>
          <el-table-column prop="doctorTeamName" label="团队名称" align='center'></el-table-column>
          <el-table-column prop="diseaseName" show-overflow-tooltip label="病种" align='center'></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 20px">
        <el-pagination background :current-page="searchParams.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="searchParams.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
      <div class="multi-send">
        <el-button @click="handleClose()" size="small">关闭</el-button>
        <el-button @click.native.prevent="assessmentSend()" :loading='sendLoding' type="primary" size="small">
          {{sendLoding?'发送中':'发送'}} </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { landeImPage, landImPush } from "../../api/index";

export default {
  props: {
    showAddQuestion: {
      type: Boolean
    },
    title: {
      type: String
    },
    topHospitalId: {
      type: String
    },
    param: {
      type: Object,
      default: {
        hospitalId: null
      }
    },
    planPage: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showAddQuestion(val) {
      this.visible = val;
      this.sendLoding = false;
      if (val) {
        this.getInitData();
      }
    }
  },
  data() {
    return {
      allCheckedList: [],
      searchList: [
        {
          label: "落地页名称",
          paramName: "name",
          inputType: "input",
          value: 1
        },
        {
          label: "展示标题名称",
          paramName: "title",
          inputType: "input",
          value: 2
        },
        {
          label: "机构名称",
          paramName: "hospitalName",
          inputType: "input",
          value: 3
        },
        {
          label: "团队名称",
          paramName: "doctorTeamName",
          inputType: "input",
          value: 4
        },
        {
          label: "展示病种",
          paramName: "diseaseId",
          inputType: "selectDisease",
          value: 5
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      sendLoding: false, 
      visible: false,  
      total: 0,
      tableData: [], 
    };
  },
  created() { 
    this.getInitData();
  },
  mounted() {},
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams }; 
      this.getInitData();
    },
    handleSelectionLandPage(val) {
      this.allCheckedList = val;
    },  
    handleClose() {
      this.$emit("update:showAddQuestion", false);
    }, 
    async getInitData() {
      let {
        code,
        data: { records, total }
      } = await landeImPage({
        ...this.searchParams,
        publishStatus: true,
        buttonType: "4"
      });
      if (code === 0) {
        this.tableData = records;
        this.total = total;
      }
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.searchParams.current = 1;
      this.getInitData();
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.getInitData();
    },
    // 发送
    async assessmentSend() {
      if (this.allCheckedList.length < 1) {
        this.$message.error("请先选择落地页！");
        return;
      }
      this.sendLoding = true;
      let ids = [];
      this.allCheckedList.map(item => {
        ids.push(item.id);
      });
      await landImPush({
        groupCode: this.param.imId?.slice(5),
        patientId: this.param.patientId,
        landingPageIds: ids,
        fromAccount: "3_" + localStorage.getItem("userid")
      })
        .then(res => {
          if (res.code == 0) {
            this.sendLoding = false;
            this.$message({
              type: "success",
              message: "推送成功"
            });
            this.handleClose();
          }
        })
        .catch(err => {
          this.sendLoding = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.multi-send {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.btn-bg {
  background: #1a7bfc;
  color: #fff;
} 
</style>
